import * as React from 'react';

function Tick(props) {
	return (
		// eslint-disable-next-line react/jsx-props-no-spreading
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="14" cy="14" r="13" fill="#8F5CE2" stroke="#AE7FF0" stroke-width="2"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.5269 9.4098C21.129 9.9788 21.1558 10.9282 20.5868 11.5303L13.0266 19.5303C12.7511 19.8219 12.3702 19.9909 11.9691 19.9996C11.5679 20.0084 11.18 19.856 10.8921 19.5767L7.45562 16.2434C6.86098 15.6666 6.84651 14.7169 7.42331 14.1223C8.00011 13.5276 8.94975 13.5132 9.54439 14.09L11.89 16.3652L18.4064 9.46974C18.9754 8.86763 19.9248 8.8408 20.5269 9.4098Z" fill="white"/>
</svg>

	);
}

export default Tick;